
// import jwt_decode from 'jwt-decode';
import { jwtDecode } from 'jwt-decode';
import zlFetch from 'zl-fetch';
import { swalAlert } from './commonService';

//const urlLogout = process.env.LOGOUT_URL;
const urlLoginRefresh = process.env.LOGINREFRESH_URL;
const urlLogout = process.env.LOGOUT_URL;

//const urlLogin = process.env.LOGIN_URL;

/* function isValidToken(exp) {
  const now = Math.floor(Date.now() / 1000);
  return exp > now;
} */

function isValidToken(exp) {
  const time = exp * 1000;
  //var diff = time - Date.now();
  if (Date.now() >= time) {
    console.log('Token er utløpt henter ny: ', new Date(time));
    return false;
  } else {
    console.log('Token utløper: ', new Date(time));
    return true;
  }
}


export async function isLoggedIn() {
  const token = localStorage.getItem('token');
  if (!token || token === 'undefined') return false;

  try {
    const decoded = jwtDecode(token);
    return isValidToken(decoded.exp);
  } catch (err) {
    console.error('Error decoding token:', err);
    return false;
  }
}

async function refreshToken(showAlertBox = true) {
  let response;
  try {
    response = await zlFetch.get(urlLoginRefresh, {
      credentials: 'include',
    });
  } catch (err) {
    if (err.status === 401) {
      if (showAlertBox) {
        swalAlert('Din sesjon har timet ut, vi prøver å forlenge din sesjon, vennligst logg inn på nytt om dette ikke lar seg gjøre');
      }
      autoRedirect();
    } else {
      const swalText = 'Klarte ikke å hente ny token, vennligst logg inn på nytt: ' + err;
      swalAlert(swalText);
      autoRedirect();
    }
    return null;
  }

  if (response?.body?.token) {
    const { token } = response.body;
    localStorage.setItem('token', token);
    return token;
  }

  return null;
}

export async function getValidToken(showAlertBox = true) {
  const validLogin = await isLoggedIn();
  if (!validLogin) {
    return await refreshToken(showAlertBox);
  } else {
    return localStorage.getItem('token');
  }
}

export async function autoRedirect() {
  const validLogin = await isLoggedIn();
  const { pathname } = new URL(window.location.href);
  const onLogin = pathname.endsWith('/login.html') || pathname === '/login';

  if (!validLogin && !onLogin) {
    location.replace('login.html');
    return;
  }
  if (validLogin && onLogin) {
    location.replace('index.html');
  }
}

export async function logout() {
  try {
    document.body.style.cursor = 'progress';
    const token = await getValidToken(true);
    await zlFetch.get(urlLogout, {
      credentials: 'include',
      auth: token
    });
    console.log('Logout OK');
  } catch (err) {
    console.error('Logout error:', err);
  } finally {
    document.body.style.cursor = 'auto';
    localStorage.removeItem('token');
    localStorage.removeItem('notFirsttime');
    autoRedirect();
  }
}


